import React from "react";
import SummaryCardLayout from "./SummaryCardLayout";
import { getFullName } from "../../../../Modules/utils/fullname";
import { RenderDenomination } from "../../../../Components/etc/RenderAmount";

export default function FinalSummaryOfficeExpense(props) {
  const { data } = props;

  const cash = Number(data.totalAmountDetails?.cashAmount || 0);
  const online = Number(data.totalAmountDetails?.onlineAmount || 0);
  const adj = Number(data.totalAmountDetails?.adjustedAmount || 0);
  const total = Number(data.totalAmount || 0);

  const INR = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");

  const renderPreviewContent = (d) => (
    <div className="p-0">
      <table className="table table-sm mb-2">
        <tbody>
          <tr>
            <td>Expense Item</td>
            <td className="text-end">{data.transactionItem}</td>
          </tr>
        </tbody>
      </table>

      <div className="fw-semibold small mt-3">Amount Summary</div>
      <table className="table table-sm mb-2">
        <tbody>
          <tr>
            <td>Cash Paid</td>
            <td className="text-end">{INR(cash)}</td>
          </tr>
          {data.totalAmountDetails.cashDenominations ? (
            <tr>
              <td className="text-muted">Denominations</td>
              <td className="text-end text-muted small">
                <RenderDenomination
                  denominations={data.totalAmountDetails.cashDenominations}
                />
              </td>
            </tr>
          ) : null}
          <tr>
            <td>Online Paid</td>
            <td className="text-end">{INR(online)}</td>
          </tr>

          {adj !== 0 && (
            <tr>
              <td>Adjustment</td>
              <td className="text-end text-danger">{INR(adj)}</td>
            </tr>
          )}
          <tr>
            <td className="fw-bold">Total Amount</td>
            <td className="text-end fw-bold">{INR(total)}</td>
          </tr>
        </tbody>
      </table>

      {d.note && (
        <>
          <div className="fw-semibold small mt-2">Note</div>
          <div className="border rounded p-2 small">{d.note}</div>
        </>
      )}
    </div>
  );

  // ----------------------------------------------------
  // Printable summary
  // ----------------------------------------------------
  const renderPrintableContent = renderPreviewContent;

  // ----------------------------------------------------
  // Determine mode
  // ----------------------------------------------------
  let mode = "preview";
  if (props.mode === "details") mode = "details";
  else if (data?.transaction?._id) mode = "submitted";

  // ----------------------------------------------------
  // Render using SummaryCardLayout wrapper
  // ----------------------------------------------------
  return (
    <SummaryCardLayout
      mode={mode}
      data={data}
      renderPreviewContent={renderPreviewContent}
      renderPrintableContent={renderPrintableContent}
      onBack={() => props.onSubmit({ step: data.step - 1 })}
      onSubmit={props.onFinalSubmit}
      onClose={props.handleClose}
      onEdit={props.handleEdit}
      onDelete={props.handleDelete}
      onApprove={props.handleApprove}
    />
  );
}
